module.exports = __webpack_public_path__ + "media/src/assets/images/property_photo4-fdf0888c244796b9bf06eb277eaaa310.jpg";